import "./styles.css";
import React from "react";
import TextField from "@mui/material/TextField";

export default function AddNote({ label, onNote, note }) {
  return (
    <div className="add-note" id="add-note-container">
      <p className="title-add-note" id="add-note-title">
        {label}
      </p>
      <TextField
        variant="outlined"
        onChange={onNote}
        value={note}
        id="add-note-text-field"
      />
    </div>
  );
}
